import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Buttons from "../../components/Button/Button";
import Inputfield from "../../components/Textfield/Textfield";
import { useHistory } from "react-router-dom";
import { listUserInfos, byUserId } from "../../graphql/queries";
import { updateUserInfo } from "../../graphql/mutations";
import { API, graphqlOperation, Auth } from "aws-amplify";
import Snackbar from "../../components/Snackbar/Snackbar";
import "./Dashboard.scss";

const Setting = () => {
	const { t } = useTranslation();
	const [uname, setName] = useState("");
	const [data, setdata] = useState(false);
	const [email, setemail] = useState("");
	const [paypalEmail, setpaypalEmail] = useState("");
	const [accountNo, setaccountNo] = useState("");
	const [ibanNo, setibanNo] = useState("");
	const [oldPass, setoldPass] = useState("");
	const [newPass, setnewpass] = useState("");
	const [confirmPass, setconfirmpass] = useState("");
	const history = useHistory();
	const [userData, setUserData] = useState({});
	const [msg, setmsg] = useState("");
	const [errMsg, seterrMsg] = useState("");
	const [loader1, setLoader1] = useState(false);
	const [loader2, setLoader2] = useState(false);
	const [loader3, setLoader3] = useState(false);

	const getUser = async (getId) => {
		try {
			let users;
			let nextTokens;
			do {
				users = await API.graphql(
					graphqlOperation(byUserId, {
						userId: getId,
						nextTokens,
						limit: 500,
					}),
				);
				nextTokens = users.data.byUserId.nextToken;
			} while (nextTokens);
			if (users) {
				setUserData(users.data.byUserId.items[0]);
				setdata(true);
			}
		} catch (error) {
			return error;
		}
	};
	useEffect(() => {
		const getId = localStorage.getItem("email");
		getUser(getId);
	}, []);

	useEffect(() => {
		if (data) {
			setName(userData?.userName);
			setemail(userData?.email);
			setaccountNo(userData?.accountNo);
			setibanNo(userData?.ibanNo);
			setpaypalEmail(userData?.paypalEmail);
		}
	}, [data]);

	const updateinfo = async () => {
		setmsg("");
		seterrMsg("");
		setLoader1(true);
		const user = {
			userName: uname,
			id: userData.id,
		};
		try {
			const data = await API.graphql(
				graphqlOperation(updateUserInfo, {
					input: user,
				}),
			);
			setmsg("Successfully added");
			setLoader1(false);
			setTimeout(function () {
				setmsg("");
			}, 2000);
		} catch (error) {
			seterrMsg(error.message);
			setLoader1(false);
			setTimeout(function () {
				seterrMsg("");
			}, 2000);
		}
	};

	const updateBank = async () => {
		setLoader2(true);
		setmsg("");
		seterrMsg("");
		const user = {
			id: userData.id,
			paypalEmail: paypalEmail,
			accountNo: accountNo,
			ibanNo: ibanNo,
		};
		try {
			const data = await API.graphql(
				graphqlOperation(updateUserInfo, {
					input: user,
				}),
			);
			setmsg("Successfully added");
			setLoader2(false);
			setTimeout(function () {
				setmsg("");
			}, 2000);
		} catch (error) {
			seterrMsg(error.message);
			setLoader2(false);
			setTimeout(function () {
				seterrMsg("");
			}, 2000);
		}
	};
	const changePass = () => {
		if (
			newPass &&
			newPass.length < 8 &&
			confirmPass &&
			newPass !== confirmPass
		) {
			setLoader3(true);
			Auth.currentAuthenticatedUser()
				.then((user) => {
					return Auth.changePassword(user, oldPass, newPass);
				})
				.then((data) => {
					setmsg("Successfully Passwordchange");
					setLoader3(false);
					setTimeout(function () {
						setmsg("");
					}, 2000);
				})
				.catch((err) => {
					seterrMsg(err.message);
					setLoader3(false);
					setTimeout(function () {
						seterrMsg("");
					}, 2000);
				});
		} else {
			seterrMsg(t("fill-requirements"));
			setTimeout(function () {
				seterrMsg("");
			}, 2000);
		}
	};
	return (
		<>
			<div className="home">
				<div className="left">
					<CustomerDashboard />
				</div>
				<div className="right">
					<div className="top" style={{ marginTop: "10px" }}>
						<h4></h4>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-arround",
								marginBottom: "10px",
							}}
						>
							<Buttons
								style={{
									width: "180px",
								}}
								text={t("new-campaign")}
								onClick={() => history.push("/")}
							/>
							<Langtrans
								style={{ marginRight: "0px", marginTop: "0px", height: "36px" }}
								dashboard
							/>
						</div>
					</div>

					<div className="bottom">
						<hr />
						<div className="field-div">
							<h3>{t("modify-inform")}</h3>
							<div className="fields" style={{ borderBottom: "none" }}>
								<span>{t("name")}: </span>
								<Inputfield
									type="text"
									placeholder={t("Enter")}
									onChange={(e) => setName(e.target.value)}
									value={uname}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<div className="fields">
								<span>Email: </span>
								<Inputfield
									type="text"
									placeholder={t("Enter")}
									value={email}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<div className="inf-btn">
								<Buttons
									text={t("update-inform")}
									style={{ width: "245px" }}
									loader={loader1}
									onClick={() => updateinfo()}
								/>
							</div>
						</div>
						<div className="field-div">
							<h3>{t("modify-inform")}</h3>
							<div className="fields" style={{ borderBottom: "none" }}>
								<span>{t("cur-pass")}: </span>
								<Inputfield
									type="password"
									placeholder={t("Enter")}
									onChange={(e) => setoldPass(e.target.value)}
									value={oldPass}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<div className="fields" style={{ borderBottom: "none" }}>
								<span>{t("new-pass")}: </span>
								<Inputfield
									type="password"
									placeholder={t("Enter")}
									onChange={(e) => setnewpass(e.target.value)}
									value={newPass}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<div className="fields">
								<span>{t("con-new-pass")}: </span>
								<Inputfield
									type="password"
									placeholder={t("Enter")}
									onChange={(e) => setconfirmpass(e.target.value)}
									value={confirmPass}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							{newPass && newPass.length < 8 && (
								<p className="errorclr" style={{ marginLeft: "10%" }}>
									{t("passworderror")}
								</p>
							)}
							{confirmPass && newPass !== confirmPass && (
								<p className="errorclr" style={{ marginLeft: "10%" }}>
									{t("pass-notmatch")}
								</p>
							)}
							<div className="inf-btn">
								<Buttons
									text={t("change-pass")}
									style={{ width: "240px" }}
									loader={loader3}
									onClick={() => changePass()}
								/>
							</div>
						</div>

						<div className="field-div">
							<h3>{t("rec-pay")}</h3>
							<h4>{t("paypal")}</h4>
							<div className="fields">
								<span>{t("pay-email")}: </span>
								<Inputfield
									type="text"
									placeholder={t("Enter")}
									onChange={(e) => setpaypalEmail(e.target.value)}
									value={paypalEmail}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<h4>{t("bank")}</h4>
							<div className="fields" style={{ borderBottom: "none" }}>
								<span>{t("acc-num")}: </span>
								<Inputfield
									type="email"
									placeholder={t("Enter")}
									onChange={(e) => setaccountNo(e.target.value)}
									value={accountNo}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<div className="fields">
								<span>{t("ban")}: </span>
								<Inputfield
									type="text"
									placeholder={t("Enter")}
									onChange={(e) => setibanNo(e.target.value)}
									value={ibanNo}
									style={{ border: "none", height: "14px" }}
								/>
							</div>
							<div className="inf-btn">
								<Buttons
									text={t("record")}
									style={{ width: "270px" }}
									loader={loader2}
									onClick={() => updateBank()}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
		</>
	);
};
export default Setting;
